import { createReducer, on } from '@ngrx/store';

import { StringPipe } from '@shared/pipes';
import { IPageOfProperty } from '@shared/models/properties';
import { IOrganization } from '@shared/models/organization';

import {
  resetOrganizationAction,
  fetchOrganizationPropertiesAction,
  fetchOrganizationPropertiesActionSuccess,
  fetchOrganizationPropertiesActionFailure,
  setOrganizationUrlSlugAction,
  getOrganizationByShortNameAction,
  getOrganizationByShortNameActionSuccess,
  getOrganizationByShortNameActionFailure,
} from './organization.actions';

import {
  setPropertyAsFavoriteActionSuccess,
  removePropertyFromFavoritesActionSuccess,
} from '../favorites/favorites.actions';

export interface OrganizationState {
  properties?: {
    loading: boolean;
    errors: boolean;
    pageOfProperties?: IPageOfProperty;
  };
  orgUrlSlug?: string | null;
  loadingOrg: boolean;
  organization?: IOrganization;
  orgFetchError: boolean;
}

export const initialState: OrganizationState = {
  properties: undefined,
  loadingOrg: false,
  orgFetchError: false,
};

export const organizationReducer = createReducer(
  initialState,
  on(resetOrganizationAction, () => ({ ...initialState })),
  on(fetchOrganizationPropertiesAction, (state) => ({
    ...state,
    properties: {
      ...state.properties,
      loading: true,
      errors: false,
    },
  })),
  on(fetchOrganizationPropertiesActionSuccess, (state, action) => ({
    ...state,
    properties: {
      ...state.properties,
      loading: false,
      errors: false,
      pageOfProperties: {
        ...action,
        results: [
          ...action.results.map((property) => ({
            ...property,
            price: new StringPipe().transform(
              property.price,
              'strPriceToDecimal'
            ),
          })),
        ],
      },
    },
  })),
  on(fetchOrganizationPropertiesActionFailure, (state) => ({
    ...state,
    properties: {
      ...state.properties,
      loading: false,
      errors: true,
    },
  })),
  on(setPropertyAsFavoriteActionSuccess, (state, action) => ({
    ...state,
    properties: state.properties
      ? {
          ...state.properties,
          pageOfProperties: state.properties.pageOfProperties
            ? {
                ...state.properties.pageOfProperties,
                results: state.properties.pageOfProperties.results.map(
                  (property) => {
                    if (property.id === action.property.id) {
                      return {
                        ...action.property,
                        price: new StringPipe().transform(
                          action.property.price,
                          'strPriceToDecimal'
                        ),
                      };
                    }
                    return property;
                  }
                ),
              }
            : undefined,
        }
      : undefined,
  })),
  on(removePropertyFromFavoritesActionSuccess, (state, action) => ({
    ...state,
    properties: state.properties
      ? {
          ...state.properties,
          pageOfProperties: state.properties.pageOfProperties
            ? {
                ...state.properties.pageOfProperties,
                results: state.properties.pageOfProperties.results.map(
                  (property) => {
                    if (property.id === action.property.id) {
                      return {
                        ...action.property,
                        price: new StringPipe().transform(
                          action.property.price,
                          'strPriceToDecimal'
                        ),
                      };
                    }
                    return property;
                  }
                ),
              }
            : undefined,
        }
      : undefined,
  })),

  on(setOrganizationUrlSlugAction, (state, action) => ({
    ...state,
    orgUrlSlug: action.slug?.toLowerCase(),
  })),
  on(getOrganizationByShortNameAction, (state) => ({
    ...state,
    loadingOrg: true,
    orgFetchError: false,
  })),
  on(getOrganizationByShortNameActionSuccess, (state, action) => ({
    ...state,
    loadingOrg: false,
    orgFetchError: false,
    organization: action.organization,
  })),
  on(getOrganizationByShortNameActionFailure, (state) => ({
    ...state,
    loadingOrg: false,
    orgFetchError: true,
  }))
);
